import { render, staticRenderFns } from "./PaidBilletCard.vue?vue&type=template&id=68cf0f64&scoped=true"
import script from "./PaidBilletCard.vue?vue&type=script&lang=js"
export * from "./PaidBilletCard.vue?vue&type=script&lang=js"
import style0 from "./PaidBilletCard.vue?vue&type=style&index=0&id=68cf0f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf0f64",
  null
  
)

export default component.exports